import React, { Component } from 'react';
import { RootState } from '../../redux/store';
import { connect } from 'react-redux';
import { ConnectedProps } from 'react-redux/es/exports';
import { DashboardState } from '../../redux/reducers/DashboardReducer';
import { AccessBase } from '../../domain/access/BaseAccess';
import { changeDashboard } from '../../redux/actions/DashboardActions';
import AccessContainer from '../access/AccessContainer';
import RoleHelper from '../../RoleHelper';

class DashboardAccessComponent extends Component<Props> {
  render() {
    const {
      dashboard: { dashboard },
    } = this.props;
    const access: AccessBase = {
      permission: dashboard.permission,
      collaborators: dashboard.collaborators,
      createdAt: dashboard.createdAt,
      updatedAt: dashboard.updatedAt,
    };
    if (!dashboard.selectedTransaction) {
      return null;
    }
    return <AccessContainer access={access} changeAccess={this.changeAccess} disabled={!RoleHelper.canManage('Dashboard')} />;
  }

  private changeAccess = (access: AccessBase) => {
    const {
      dashboard: { dashboard },
      changeDashboard,
    } = this.props;
    dashboard.permission = access.permission;
    dashboard.collaborators = access.collaborators;
    changeDashboard(dashboard);
  };
}

interface Props extends ReduxProps {}

const mapStateToProps = (state: RootState) => ({
  dashboard: state.dashboard as DashboardState,
});

const mapDispatchToProps = { changeDashboard };
const connector = connect(mapStateToProps, mapDispatchToProps);
type ReduxProps = ConnectedProps<typeof connector>;
export default connector(DashboardAccessComponent);
